import { Button, message } from "antd";
import { FC, ReactNode, useEffect, useState } from "react";
import EmailFormStep from "./registerFormSteps/EmailFormStep";
import NameAndPasswordStep from "./registerFormSteps/NameAndPasswordStep";
import PhoneNumberStep from "./registerFormSteps/PhoneNumberStep";
import OtpStep from "./registerFormSteps/OtpStep";
import { useMutation } from "@tanstack/react-query";
import { authReSendOtp } from "../../../network/auth";
import { useSearchParams } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

interface RegisterFormProps {}
export type registerDataType = {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  phone: string;
  phone_country_code: string;
};

const RegisterForm: FC<RegisterFormProps> = ({}) => {
  const intl = useIntl();
  const { currentLang } = useSelector(
    (state: { user: { currentLang: string } }) => state.user
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const [stepIndex, setStepIndex] = useState(
    searchParams.get("step") &&
      Number(searchParams.get("step")) >= 0 &&
      Number(searchParams.get("step")) <= 3
      ? Number(searchParams.get("step"))
      : 0
  );
  useEffect(() => {
    setStepIndex(
      searchParams.get("step") &&
        Number(searchParams.get("step")) >= 0 &&
        Number(searchParams.get("step")) <= 3
        ? Number(searchParams.get("step"))
        : 0
    );
  }, [searchParams]);

  const [registerData, setRegisterData] = useState<registerDataType>({
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    phone: "",
    phone_country_code: "",
  });
  useEffect(() => {
    if (
      !registerData.email ||
      !registerData.password ||
      !registerData.firstName ||
      !registerData.lastName ||
      !registerData.phone
    ) {
      searchParams.set("step", "0");
      setSearchParams(searchParams);
      return;
    }
  }, []);

  const addRegisterData = (data: Partial<registerDataType>) => {
    if (data === null) {
      return;
    }
    setRegisterData((prev) => {
      return {
        ...prev,
        ...data,
      };
    });
  };
  const nextStep = () => {
    if (stepIndex < steps.length - 1) {
      searchParams.set("step", `${stepIndex + 1}`);
      setSearchParams(searchParams);
      setStepIndex((prev) => prev + 1);
    }
    return false;
  };
  const prevStep = () => {
    if (stepIndex > 0) {
      searchParams.set("step", `${stepIndex - 1}`);
      setSearchParams(searchParams);
      setStepIndex((prev) => prev - 1);
    }
    return false;
  };
  const reSendOtp = async () => {
    if (!registerData.phone) return;
    return authReSendOtp({
      phone: `${registerData.phone_country_code}${registerData.phone}`,
    });
    // reSendOtpMutate.mutate({
    //   phone: `${registerData.phone_country_code}${registerData.phone}`,
    // });
    // if (reSendOtpMutate.isSuccess) {
    //   message.success("تم ارسال رمز التحقق بنجاح");
    // } else {
    //   message.error("حاول مرة اخرى");
    // }
  };
  const steps: ReactNode[] = [
    <EmailFormStep
      nextStep={nextStep}
      addRegisterData={addRegisterData}
      registerData={registerData}
    />,
    <NameAndPasswordStep
      nextStep={nextStep}
      addRegisterData={addRegisterData}
      registerData={registerData}
    />,
    <PhoneNumberStep
      nextStep={nextStep}
      addRegisterData={addRegisterData}
      registerData={registerData}
    />,
    <OtpStep
      reSendOtp={reSendOtp}
      phoneDetails={{
        phone: registerData.phone,

        phone_country_code: registerData.phone_country_code,
      }}
    />,
  ];

  return (
    <div>
      {stepIndex >= 1 && stepIndex < 3 ? (
        <div
          className={`absolute -top-10 ${
            currentLang === "ar" ? "-right-7" : "-left-7"
          } w-full`}
        >
          <Button type="link" htmlType="button" onClick={prevStep}>
            <span className="w-full text-sm font-normal text-color-gray items-center flex  gap-2">
              {currentLang === "ar" ? (
                <IoIosArrowForward color="gray" />
              ) : (
                <IoIosArrowBack color="gray" />
              )}
              <span className=""> {intl.formatMessage({ id: "back" })}</span>{" "}
            </span>
          </Button>
        </div>
      ) : null}
      {steps[stepIndex]}
    </div>
  );
};

export default RegisterForm;
